// Starter spec.rules for a freshly-created generic-webhook Integration
// (roadmap #9 Phase 1 slice 6, the setup-flow half). Point-and-click
// authoring of rules is explicitly not this slice - see
// docs/CLAUDE_ZMIST_INTEGRATION_TOOL_IMPLEMENTATION.md §7.7, Advanced JSON
// is the design's own sanctioned fallback - so a new webhook mapping needs
// *something* real to look at in that editor and in the read-only preview.
//
// Not invented here: this is zagentc/README.md's own "generic mapping"
// canonical example (the sourceType: "json"/"csv" section), with the
// agent-only fields (target/recordPath/intervalSec) dropped since they
// don't apply to a webhook push. It's a documented reference shape to
// learn from, not a working default for anyone's actual payload.
export const STARTER_RULES = [
  { to: 'name', const: 'event' },
  { to: 'value', from: 'value', cast: 'number' },
  { to: 'labels.type', from: 'type' },
];

export function starterWebhookSpec(channelNickname: string): Record<string, unknown> {
  return { provider: 'generic', channel: channelNickname, rules: STARTER_RULES };
}
